import { h } from 'vue';
import Image from './component-lib.esm3.js';
import Video from './component-lib.esm2.js';
const vueSlot = (s, attrs) => {
  if (typeof s == 'function') return s(attrs);
  return s;
};
const getRender = type => {
  switch (type) {
    case 'image':
      return Image;
    case 'video':
      return Video;
    default:
      throw new Error(`Did not find a render for type ${type}`);
  }
};
const render = (_ref, $slots) => {
  let {
    story,
    isPaused,
    onAction
  } = _ref;
  const attrs = {
    props: {
      story,
      isPaused
    },
    on: {
      action: onAction
    }
  };
  const {
    type,
    template
  } = story;
  if (template) {
    const slot = $slots[template];
    if (!slot) throw new Error(`unable to find the template '${template}'`);
    return vueSlot(slot, attrs);
  }
  return h(getRender(type), attrs);
};
var render$1 = render;
export { render$1 as default };